import { japaneseMovies, japaneseMoviesForEnUs } from '../data/japaneseMovies/japaneseMovies.data';
import { MoviesTagPageContent } from '../MoviesTagPageContent';
import { TagPageProps } from '../types/tagPageProps';

export const Content = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={japaneseMovies} />
);

export const ContentEnUs = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={japaneseMoviesForEnUs} />
);
